module.exports = __webpack_public_path__ + "img/nbus_main_title2.b2724a05.png";